import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-month-wise-business-report',
  templateUrl: './month-wise-business-report.component.html',
  styleUrl: './month-wise-business-report.component.scss'
})
export class MonthWiseBusinessReportComponent implements OnInit {

  subTypesName: any[] = [];
  offrepwiseData: any[] = [];
  startDate: string = '';
  endDate: string = '';
  getallVouchersData: any[] = [];
  expenseLedgerData: any[] = [];
  appliedFilters: any = {};
  isLoading: boolean = false;
  today: Date = new Date();
  lastYearMonthData: { [key: string]: number } = {};
  lastYearMonthSubCount: { [key: string]: number } = {};

  lastYearTotalAmount: number = 0;
  lastYearNavin: number = 0;
  lastYearNutnikaran: number = 0;
  lastYearNutnikaranBaki: number = 0;

  lastYearExpenseLedgerData: any[] = [];
  lastYearVouchersData: any[] = [];

  private lastYearExpenseLoaded = false;
  private lastYearVouchersLoaded = false;

  monthColumns: string[] = [
    'एप्रिल', 'मे', 'जून', 'जुलै', 'ऑगस्ट', 'सप्टेंबर',
    'ऑक्टोबर', 'नोव्हेंबर', 'डिसेंबर', 'जानेवारी', 'फेब्रुवारी', 'मार्च'
  ];

  monthKeys: string[] = [
    'april', 'may', 'june', 'july', 'august', 'september',
    'october', 'november', 'december', 'january', 'february', 'march'
  ];

  financialMonthMap: { [key: number]: string } = {
    3: 'april',
    4: 'may',
    5: 'june',
    6: 'july',
    7: 'august',
    8: 'september',
    9: 'october',
    10: 'november',
    11: 'december',
    0: 'january',
    1: 'february',
    2: 'march'
  };




  fiscalYear: string = '';
  private readonly UDHISTHA_API = 'https://vivekweb.in/VivekApplication/getMonthwiseBusinessUdhistha.php';

  OFFICE_REP_ORDER: string[] = [
    'दयानंद शिवशिवकर', 'प्रदीप निकम', 'धनाजी जाधव',
    'राजेश गावडे', 'संजय शिवगण', 'कार्यालय-वर्गणी विक्री विभाग'
  ];

  readonly DEPOSIT_TYPE = 'मुदत ठेव (पंचवार्षिक वर्गणीदार)';

  officeRepRows: any[] = [];
  grandTotalRow: any = {};
  // lastYearTotalAmount: number = 0;

  private expenseLoaded = false;
  private vouchersLoaded = false;

  marathiMonths: { [key: string]: string } = {
    'January': 'जानेवारी', 'February': 'फेब्रुवारी', 'March': 'मार्च',
    'April': 'एप्रिल', 'May': 'मे', 'June': 'जून',
    'July': 'जुलै', 'August': 'ऑगस्ट', 'September': 'सप्टेंबर',
    'October': 'ऑक्टोबर', 'November': 'नोव्हेंबर', 'December': 'डिसेंबर'
  };
  lastYearMonthBuckets: any;
  lastYearTotal: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<MonthWiseBusinessReportComponent>,
    private service: DigisubservicesService
  ) {
    this.offrepwiseData = data?.offrepwisedata || [];
    this.startDate = data?.startDate || '';
    this.endDate = data?.endDate || '';
    this.appliedFilters = data?.appliedFilters || {};
  }

  //   ngOnInit(): void {




  //     // Temporarily add in ngOnInit() after buildLastYearMonthData call:
  // console.log('startDate:', this.startDate);
  // console.log('endDate:', this.endDate);
  // const s = this.parseDate(this.startDate);
  // const e = this.parseDate(this.endDate);
  // console.log('Parsed start:', s);
  // console.log('Parsed end:', e);
  // console.log('Same month?', s?.getMonth() === e?.getMonth() && s?.getFullYear() === e?.getFullYear());



  //     this.isLoading = true;
  //     const lastYearRaw = this.data?.lastYearOffrepwisedata || [];
  //     this.buildLastYearMonthData(lastYearRaw);

  //     if (!this.startDate || !this.endDate) {
  //       this.expenseLoaded = true;
  //       this.vouchersLoaded = true;
  //       this.buildMonthWiseData();
  //       return;
  //     }
  //     this.loadExpenseData();
  //     this.loadVouchersData();
  //   }

  // ngOnInit(): void {
  //   this.isLoading = true;

  //   const lastYearRaw = this.data?.lastYearOffrepwisedata || [];
  //   this.buildLastYearMonthData(lastYearRaw);

  //   // ✅ ADD THIS TEMPORARILY — find the ₹2800 record
  //   const missing = lastYearRaw.filter((r: any) => Number(r.total_amt) === 2800);
  //   console.log('🔍 ₹2800 records:', missing);
  //   console.log('🔍 All fields of ₹2800 record:', missing[0] ? Object.entries(missing[0]) : 'NOT FOUND BY AMT');

  //   // Also check skipped records by amount
  //   const aprilRaw = lastYearRaw.filter((r: any) => {
  //     const dates = [r.rcpt_date, r.crdt_voucher_date, r.entry_date, r.rcpt_entry_date];
  //     return dates.some(d => d && d.toString().startsWith('2025-04'));
  //   });
  //   console.log('🔍 April records (by any date field):', aprilRaw.length, 
  //               '| total:', aprilRaw.reduce((s: number, r: any) => s + (Number(r.total_amt) || 0), 0));

  //   // Records with NO valid date at all
  //   const noDates = lastYearRaw.filter((r: any) => {
  //     const amt = Number(r.total_amt) || 0;
  //     if (!amt) return false;
  //     const fields = [r.rcpt_date, r.crdt_voucher_date, r.entry_date, r.rcpt_entry_date, r.created_at];
  //     return fields.every(d => !d || d.toString().startsWith('0000') || d === 'null');
  //   });
  //   console.log('🔍 Records with NO valid date:', noDates.length);
  //   console.log('🔍 NO-DATE records detail:', noDates.map((r: any) => ({
  //     all_keys: Object.keys(r),
  //     all_values: Object.entries(r),
  //     amt: r.total_amt,
  //     rep: r.office_rep_name
  //   })));

  //   if (!this.startDate || !this.endDate) {
  //     this.expenseLoaded = true;
  //     this.vouchersLoaded = true;
  //     this.buildMonthWiseData();
  //     return;
  //   }
  //   this.loadExpenseData();
  //   this.loadVouchersData();
  // }

  // ngOnInit(): void {
  //   this.isLoading = true;

  //   const lastYearRaw = this.data?.lastYearOffrepwisedata || [];

  //   if (!this.startDate || !this.endDate) {
  //     this.expenseLoaded = true;
  //     this.vouchersLoaded = true;
  //     this.lastYearExpenseLoaded = true;
  //     this.lastYearVouchersLoaded = true;
  //     this.buildMonthWiseData();
  //     this.buildLastYearMonthData(lastYearRaw);
  //     return;
  //   }

  //   this.loadExpenseData();
  //   this.loadVouchersData();
  //   this.loadLastYearExpenseData();   // ✅ fetches last year donations
  //   this.loadLastYearVouchersData();  // ✅ fetches last year pending
  // }

  ngOnInit(): void {
    this.isLoading = true;

    const lastYearRaw = this.data?.lastYearOffrepwisedata || [];

    if (!this.startDate || !this.endDate) {
      this.expenseLoaded = true;
      this.vouchersLoaded = true;
      this.lastYearExpenseLoaded = true;
      this.lastYearVouchersLoaded = true;
      this.buildMonthWiseData();
      this.buildLastYearMonthData(lastYearRaw);
      return;
    }
    const sd = this.parseDate(this.startDate);
    if (sd) {
      const y = sd.getMonth() >= 3 ? sd.getFullYear() : sd.getFullYear() - 1;
      this.fiscalYear = `${y}-${String(y + 1).slice(-2)}`;  // e.g. "2026-27"
    }

    // Current year — loads then calls buildMonthWiseData via tryBuild()
    this.loadExpenseData();
    this.loadVouchersData();

    // Last year — loads then calls buildLastYearMonthData via tryBuildLastYear()
    this.loadLastYearExpenseData();
    this.loadLastYearVouchersData();
  }


  parseDate(dateStr: any): Date | null {
    if (!dateStr) return null;
    try {
      const s = dateStr.toString().trim();
      const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (iso) return new Date(+iso[1], +iso[2] - 1, +iso[3]);
      const dmy = s.match(/^(\d{2})-(\d{2})-(\d{4})$/);
      if (dmy) return new Date(+dmy[3], +dmy[2] - 1, +dmy[1]);
      const dmyS = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (dmyS) return new Date(+dmyS[3], +dmyS[2] - 1, +dmyS[1]);
      const d = new Date(dateStr);
      return isNaN(d.getTime()) ? null : d;
    } catch { return null; }
  }

  private monthKeyOf(dateStr: any): string | null {
    const d = this.parseDate(dateStr);
    if (!d || isNaN(d.getTime())) return null;
    return this.financialMonthMap[d.getMonth()] ?? null;
  }

  // ─────────────────────────────────────────────────────────────────────────
  // buildLastYearMonthData — DEFINITIVE FIX
  //
  // THE ACTUAL ROOT CAUSE (finally):
  //
  //   Current year view = Apr 2026 to Mar 2027 (full year, isSingleMonth=false)
  //   So fixedMonthKey = null → each record needs its OWN date to bucket.
  //
  //   BUT: the old code used this.startDate / this.endDate for the
  //   isSingleMonth check inside buildLastYearMonthData too.
  //   That is correct — full year → fixedMonthKey = null — so it DID try
  //   to read dates from lastYearData records.
  //
  //   THE ACTUAL PROBLEM: lastYearData records genuinely have NO date fields
  //   (rcpt_date = null, crdt_voucher_date = null, etc.) because the backend
  //   query for lastYearOffrepwisedata is an AGGREGATE query — it groups by
  //   office_rep_name + subscription_type and SUMs total_amt, but does NOT
  //   return individual dates (they get lost in the GROUP BY).
  //
  //   PROOF: April shows 432,500 (correct) and May shows 566,000 (correct)
  //   in Image 1. In Image 2, only 753,000 (Apr) and 268,100 (May) show —
  //   these are NOT last year's Apr+May amounts. They are the CURRENT year's
  //   own data being accidentally reused. The last year month data is ALL ZERO
  //   except where fixedMonthKey accidentally put something.
  //
  //   SOLUTION: Since lastYearData has no dates, we CANNOT bucket by date.
  //   Instead, call buildMonthWiseData-equivalent logic on lastYearData
  //   but treating it as a FULL YEAR (Apr-Mar). Since we have no dates,
  //   we need the backend to either:
  //     (a) return month field in lastYearData, OR
  //     (b) we use the financial_month or month_number field if present
  //
  //   IMMEDIATE FIX that works without backend change:
  //   Check if record has a 'month' / 'month_no' / 'financial_month' field.
  //   These are commonly returned by aggregate queries.
  // ─────────────────────────────────────────────────────────────────────────
  // buildLastYearMonthData(lastYearData: any[]): void {
  //   this.lastYearMonthData = {};
  //   this.monthKeys.forEach(k => this.lastYearMonthData[k] = 0);
  //   this.lastYearTotalAmount = 0;

  //   if (!lastYearData?.length) return;

  //   // ── Log sample to find available fields ──────────────────────────────────
  //   if (lastYearData.length > 0) {
  //     console.warn('▶▶▶ LAST YEAR SAMPLE RECORD — find date or month field:');
  //     console.warn(lastYearData[0]);
  //     console.warn('▶▶▶ ALL KEYS:', Object.keys(lastYearData[0]));
  //   }

  //   const lastYearStart = this.getLastYearStartDate();
  //   const lastYearEnd   = this.getLastYearEndDate();

  //   const isSingleMonth =
  //     lastYearStart.getFullYear() === lastYearEnd.getFullYear() &&
  //     lastYearStart.getMonth()    === lastYearEnd.getMonth();

  //   const fixedMonthKey = isSingleMonth
  //     ? (this.financialMonthMap[lastYearStart.getMonth()] ?? null)
  //     : null;

  //   // Month number → financial month key map (for month_no / month field)
  //   // month_no: 1=Jan, 2=Feb ... 12=Dec  OR  1=Apr, 2=May (financial)
  //   // We handle both conventions below
  //   const calendarMonthNoToKey: { [n: number]: string } = {
  //     1: 'january', 2: 'february', 3: 'march',
  //     4: 'april', 5: 'may', 6: 'june',
  //     7: 'july', 8: 'august', 9: 'september',
  //     10: 'october', 11: 'november', 12: 'december'
  //   };
  //   const financialMonthNoToKey: { [n: number]: string } = {
  //     1: 'april', 2: 'may', 3: 'june',
  //     4: 'july', 5: 'august', 6: 'september',
  //     7: 'october', 8: 'november', 9: 'december',
  //     10: 'january', 11: 'february', 12: 'march'
  //   };

  //   let placed = 0;
  //   let noDateCount = 0;
  //   let noDateAmount = 0;

  //   lastYearData.forEach((record: any) => {
  //     const amt = Number(record.total_amt) || 0;
  //     if (!amt) return;

  //     let mk: string | null = null;

  //     if (fixedMonthKey) {
  //       mk = fixedMonthKey;
  //     } else {

  //       // ── STRATEGY 1: Try all date fields ──────────────────────────────
  //       const dateStr =
  //         record.rcpt_date         ||
  //         record.crdt_voucher_date ||
  //         record.rcpt_entry_date   ||
  //         record.entry_date        ||
  //         record.created_at        ||
  //         record.receipt_date      ||
  //         record.voucher_date      ||
  //         record.payment_date      ||
  //         record.sub_date          ||
  //         record.subscription_date ||
  //         record.date              ||
  //         record.trans_date        ||
  //         record.transaction_date  ||
  //         record.rcpt_dt           ||
  //         record.entry_dt          ||
  //         record.pay_date          ||
  //         record.paid_date         ||
  //         record.effective_date    ||
  //         record.posting_date;

  //       if (dateStr) mk = this.monthKeyOf(dateStr);

  //       // ── STRATEGY 2: Try month number fields (aggregate queries) ───────
  //       if (!mk) {
  //         // financial_month: 1=Apr ... 12=Mar
  //         const finMonth = Number(record.financial_month || record.fin_month);
  //         if (finMonth >= 1 && finMonth <= 12) {
  //           mk = financialMonthNoToKey[finMonth] ?? null;
  //         }
  //       }

  //       if (!mk) {
  //         // month_no / month: 1=Jan ... 12=Dec (calendar)
  //         const calMonth = Number(
  //           record.month_no || record.month_num ||
  //           record.month    || record.mnth
  //         );
  //         if (calMonth >= 1 && calMonth <= 12) {
  //           mk = calendarMonthNoToKey[calMonth] ?? null;
  //         }
  //       }

  //       if (!mk) {
  //         // month_name field (English)
  //         const mName = (record.month_name || record.mnth_name || '').toString().trim().toLowerCase();
  //         const nameMap: { [k: string]: string } = {
  //           'january': 'january', 'february': 'february', 'march': 'march',
  //           'april': 'april', 'may': 'may', 'june': 'june',
  //           'july': 'july', 'august': 'august', 'september': 'september',
  //           'october': 'october', 'november': 'november', 'december': 'december',
  //           'jan': 'january', 'feb': 'february', 'mar': 'march',
  //           'apr': 'april', 'jun': 'june', 'jul': 'july',
  //           'aug': 'august', 'sep': 'september', 'oct': 'october',
  //           'nov': 'november', 'dec': 'december'
  //         };
  //         if (mName && nameMap[mName]) mk = nameMap[mName];
  //       }
  //     }

  //     if (mk) {
  //       this.lastYearMonthData[mk] += amt;
  //       this.lastYearTotalAmount   += amt;
  //       placed++;
  //     } else {
  //       // Truly no month resolvable
  //       this.lastYearTotalAmount += amt;
  //       noDateCount++;
  //       noDateAmount += amt;
  //     }
  //   });

  //   // ── Result log ──────────────────────────────────────────────────────────
  //   console.group('▶▶▶ LAST YEAR BUILD RESULT');
  //   console.log('Records placed into month columns:', placed);
  //   console.log('Records with NO date/month field :', noDateCount, `(₹${noDateAmount.toLocaleString('en-IN')})`);
  //   console.log('lastYearTotalAmount:', this.lastYearTotalAmount);
  //   console.log('Month breakdown:', { ...this.lastYearMonthData });

  //   if (noDateCount > 0) {
  //     console.error(
  //       `❌ ${noDateCount} records (₹${noDateAmount.toLocaleString('en-IN')}) ` +
  //       `have NO date or month field.\n` +
  //       `Open "ALL KEYS" above → find a field containing:\n` +
  //       `  • A date string like "2025-04-15"\n` +
  //       `  • A month number like 4 (for April)\n` +
  //       `  • A month name like "April"\n` +
  //       `Then paste that field name here and I will add it in one line.`
  //     );
  //     console.error('First no-date record:', lastYearData.find((r: any) => {
  //       const amt = Number(r.total_amt) || 0;
  //       if (!amt) return false;
  //       const dateStr = r.rcpt_date || r.crdt_voucher_date || r.rcpt_entry_date ||
  //         r.entry_date || r.created_at || r.receipt_date || r.voucher_date ||
  //         r.payment_date || r.sub_date || r.date || r.trans_date;
  //       const finMonth = Number(r.financial_month || r.fin_month);
  //       const calMonth = Number(r.month_no || r.month_num || r.month || r.mnth);
  //       return !dateStr && !(finMonth >= 1 && finMonth <= 12) && !(calMonth >= 1 && calMonth <= 12);
  //     }));
  //   } else {
  //     console.log('✅ All records placed — मागील वर्षीचा व्यवसाय row will show correct amounts!');
  //   }
  //   console.groupEnd();
  // }


  // buildLastYearMonthData(lastYearData: any[]): void {

  //   this.lastYearMonthData = {};
  //   this.monthKeys.forEach(k => this.lastYearMonthData[k] = 0);
  //   this.lastYearTotalAmount = 0;

  //   if (!lastYearData || !lastYearData.length) return;

  //   const lastYearStart = this.getLastYearStartDate();
  //   const lastYearEnd = this.getLastYearEndDate();

  //   const isSingleMonth =
  //     lastYearStart.getFullYear() === lastYearEnd.getFullYear() &&
  //     lastYearStart.getMonth() === lastYearEnd.getMonth();

  //   const fixedMonthKey = isSingleMonth
  //     ? (this.financialMonthMap[lastYearStart.getMonth()] ?? null)
  //     : null;

  //   lastYearData.forEach((record: any) => {

  //     const amt = Number(record.total_amt) || 0;
  //     if (!amt) return;

  //     let mk: string | null = null;

  //     // SINGLE MONTH REPORT
  //     if (fixedMonthKey) {
  //       mk = fixedMonthKey;
  //     }
  //     else {

  //       // EXACT SAME LOGIC AS CURRENT YEAR
  //       // FIRST PRIORITY → direct month field
  //       const monthField =
  //         (record.month_name ||
  //           record.month ||
  //           record.mnth ||
  //           '').toString().trim().toLowerCase();

  //       const monthMap: any = {
  //         january: 'january',
  //         february: 'february',
  //         march: 'march',
  //         april: 'april',
  //         may: 'may',
  //         june: 'june',
  //         july: 'july',
  //         august: 'august',
  //         september: 'september',
  //         october: 'october',
  //         november: 'november',
  //         december: 'december'
  //       };

  //       if (monthField && monthMap[monthField]) {
  //         mk = monthMap[monthField];
  //       }
  //       else {

  //         // fallback to date
  //         const dateStr =
  //           record.rcpt_date ||
  //           record.crdt_voucher_date ||
  //           record.rcpt_entry_date ||
  //           record.entry_date ||
  //           record.created_at;

  //         if (dateStr) {
  //           mk = this.monthKeyOf(dateStr);
  //         }
  //       }

  //       // IMPORTANT FIX
  //       // If backend already sends month_name or month_no
  //       if (!mk) {

  //         // month number support
  //         const monthNo = Number(
  //           record.month_no ||
  //           record.month_num ||
  //           record.month
  //         );

  //         if (monthNo >= 1 && monthNo <= 12) {

  //           const calendarMap: any = {
  //             1: 'january',
  //             2: 'february',
  //             3: 'march',
  //             4: 'april',
  //             5: 'may',
  //             6: 'june',
  //             7: 'july',
  //             8: 'august',
  //             9: 'september',
  //             10: 'october',
  //             11: 'november',
  //             12: 'december'
  //           };

  //           mk = calendarMap[monthNo];
  //         }
  //       }

  //       // month name support
  //       if (!mk) {

  //         const monthName =
  //           (record.month_name || '')
  //             .toString()
  //             .trim()
  //             .toLowerCase();

  //         const monthNameMap: any = {
  //           january: 'january',
  //           february: 'february',
  //           march: 'march',
  //           april: 'april',
  //           may: 'may',
  //           june: 'june',
  //           july: 'july',
  //           august: 'august',
  //           september: 'september',
  //           october: 'october',
  //           november: 'november',
  //           december: 'december'
  //         };

  //         mk = monthNameMap[monthName] || null;
  //       }
  //     }

  //     // FINAL ADDITION
  //     if (mk) {
  //       this.lastYearMonthData[mk] =
  //         (this.lastYearMonthData[mk] || 0) + amt;
  //     }

  //     this.lastYearTotalAmount += amt;
  //   });

  //   console.log('LAST YEAR MONTH DATA', this.lastYearMonthData);
  // }

  // buildLastYearMonthData(lastYearData: any[]): void {
  //   this.lastYearMonthData = {};
  //   this.monthKeys.forEach(k => this.lastYearMonthData[k] = 0);
  //   this.lastYearTotalAmount = 0;

  //   if (!lastYearData?.length) return;

  //   const lastYearStart = this.getLastYearStartDate();
  //   const lastYearEnd   = this.getLastYearEndDate();

  //   const isSingleMonth =
  //     lastYearStart.getFullYear() === lastYearEnd.getFullYear() &&
  //     lastYearStart.getMonth()    === lastYearEnd.getMonth();

  //   const fixedMonthKey = isSingleMonth
  //     ? (this.financialMonthMap[lastYearStart.getMonth()] ?? null)
  //     : null;

  //   // lastYearData.forEach((record: any) => {
  //   //   const amt = Number(record.total_amt) || 0;
  //   //   if (!amt) return;

  //   //   let mk: string | null = null;

  //   //   if (fixedMonthKey) {
  //   //     mk = fixedMonthKey;
  //   //   } else {
  //   //     // ✅ crdt_voucher_date first — same field as current year offrepwiseData
  //   //     mk = this.monthKeyOf(record.crdt_voucher_date || record.entry_date);
  //   //   }

  //   //   if (mk) {
  //   //     this.lastYearMonthData[mk] = (this.lastYearMonthData[mk] || 0) + amt;
  //   //   }
  //   //   this.lastYearTotalAmount += amt;
  //   // });




  //   console.log('LAST YEAR MONTH DATA:', { ...this.lastYearMonthData });
  //   console.log('LAST YEAR TOTAL:', this.lastYearTotalAmount);
  // }

  // buildLastYearMonthData(lastYearData: any[]): void {
  //   this.lastYearMonthData = {};
  //   this.monthKeys.forEach(k => this.lastYearMonthData[k] = 0);
  //   this.lastYearTotalAmount = 0;

  //   if (!lastYearData?.length) return;

  //   const lastYearStart = this.getLastYearStartDate();
  //   const lastYearEnd   = this.getLastYearEndDate();

  //   const isSingleMonth =
  //     lastYearStart.getFullYear() === lastYearEnd.getFullYear() &&
  //     lastYearStart.getMonth()    === lastYearEnd.getMonth();

  //   const fixedMonthKey = isSingleMonth
  //     ? (this.financialMonthMap[lastYearStart.getMonth()] ?? null)
  //     : null;

  //   // For debugging — remove after fix confirmed
  //   const skipped: any[] = [];
  //   const placed: any[] = [];

  //   lastYearData.forEach((record: any) => {
  //     const amt = Number(record.total_amt) || 0;
  //     if (!amt) return;

  //     // ✅ CRITICAL: Skip DEPOSIT_TYPE — same as buildMonthWiseData()
  //     // Deposits are tracked separately; including them causes double count
  //     if (record.subscription_type === this.DEPOSIT_TYPE) return;

  //     let mk: string | null = null;

  //     if (fixedMonthKey) {
  //       // Single month report — all records go to fixed month
  //       mk = fixedMonthKey;
  //     } else {
  //       // ✅ Use crdt_voucher_date FIRST (actual transaction date)
  //       // This matches how current year offrepwiseData is bucketed
  //       // entry_date is only a fallback (it can be days later)
  //       const dateStr =
  //         record.crdt_voucher_date ||  // actual voucher date — PRIMARY
  //         record.entry_date;           // entry date — FALLBACK only

  //       mk = this.monthKeyOf(dateStr);
  //     }

  //     if (mk) {
  //       this.lastYearMonthData[mk] = (this.lastYearMonthData[mk] || 0) + amt;
  //       this.lastYearTotalAmount += amt;
  //       placed.push({ rep: record.rep_name, mk, amt, date: record.crdt_voucher_date || record.entry_date });
  //     } else {
  //       // No date resolved — still count in total
  //       this.lastYearTotalAmount += amt;
  //       skipped.push({ rep: record.rep_name, amt, record });
  //     }
  //   });

  //   // ✅ Debug logs — check these vs Image 1 values
  //   console.group('=== LAST YEAR MONTH DATA ===');
  //   console.log('Month breakdown:', { ...this.lastYearMonthData });
  //   console.log('Total amount:', this.lastYearTotalAmount);
  //   console.log('Records placed:', placed.length);
  //   console.log('Records skipped (no date):', skipped.length);
  //   if (skipped.length) {
  //     console.warn('Skipped records:', skipped);
  //   }
  //   // Check May specifically
  //   const mayRecords = placed.filter(p => p.mk === 'may');
  //   console.log('MAY records count:', mayRecords.length, 
  //               '| MAY total:', mayRecords.reduce((s, r) => s + r.amt, 0));
  //   console.groupEnd();
  // }

  // buildLastYearMonthData(lastYearData: any[]): void {
  //   this.lastYearMonthData = {};
  //   this.monthKeys.forEach(k => this.lastYearMonthData[k] = 0);
  //   this.lastYearTotalAmount = 0;

  //   // ✅ Use pre-bucketed data from parent if available (preferred)
  //   if (this.data?.lastYearMonthBuckets &&
  //       Object.keys(this.data.lastYearMonthBuckets).length > 0) {

  //     this.lastYearMonthData  = { ...this.data.lastYearMonthBuckets };
  //     this.lastYearTotalAmount = this.data.lastYearTotal || 0;

  //     console.log('✅ Using pre-bucketed lastYearMonthData:', this.lastYearMonthData);
  //     console.log('✅ lastYearTotalAmount:', this.lastYearTotalAmount);
  //     return;
  //   }

  //   // Fallback: bucket here if pre-bucketed data not available
  //   if (!lastYearData?.length) return;

  //   const lastYearStart = this.getLastYearStartDate();
  //   const lastYearEnd   = this.getLastYearEndDate();

  //   const isSingleMonth =
  //     lastYearStart.getFullYear() === lastYearEnd.getFullYear() &&
  //     lastYearStart.getMonth()    === lastYearEnd.getMonth();

  //   const fixedMonthKey = isSingleMonth
  //     ? (this.financialMonthMap[lastYearStart.getMonth()] ?? null)
  //     : null;

  //   lastYearData.forEach((record: any) => {
  //     const amt = Number(record.total_amt) || 0;
  //     if (amt <= 0) return;

  //     let mk: string | null = null;

  //     if (fixedMonthKey) {
  //       mk = fixedMonthKey;
  //     } else {
  //       const dateStr =
  //         record.crdt_voucher_date ||
  //         record.rcpt_date         ||
  //         record.entry_date        ||
  //         record.created_at;

  //       if (!dateStr || dateStr.startsWith('0000')) return;
  //       mk = this.monthKeyOf(dateStr);
  //     }

  //     if (mk) {
  //       this.lastYearMonthData[mk] = (this.lastYearMonthData[mk] || 0) + amt;
  //       this.lastYearTotalAmount += amt;
  //     }
  //   });

  //   console.log('LAST YEAR RESULT (fallback):', { ...this.lastYearMonthData });
  //   console.log('LAST YEAR TOTAL (fallback):', this.lastYearTotalAmount);
  // }

  // buildLastYearMonthData(lastYearData: any[]): void {
  //   this.lastYearMonthData = {};
  //   this.monthKeys.forEach(k => this.lastYearMonthData[k] = 0);
  //   this.lastYearTotalAmount = 0;

  //   if (!lastYearData?.length) {
  //     console.warn('⚠️ buildLastYearMonthData: NO lastYearData received');
  //     return;
  //   }

  //   console.group('=== buildLastYearMonthData DEBUG ===');
  //   console.log('Total records received:', lastYearData.length);
  //   console.log('Total raw amount:', lastYearData.reduce((s, r) => s + (Number(r.total_amt) || 0), 0));
  //   console.log('Sample record keys:', Object.keys(lastYearData[0] || {}));
  //   console.log('Sample record:', lastYearData[0]);

  //   const lastYearStart = this.getLastYearStartDate();
  //   const lastYearEnd   = this.getLastYearEndDate();

  //   const isSingleMonth =
  //     lastYearStart.getFullYear() === lastYearEnd.getFullYear() &&
  //     lastYearStart.getMonth()    === lastYearEnd.getMonth();

  //   const fixedMonthKey = isSingleMonth
  //     ? (this.financialMonthMap[lastYearStart.getMonth()] ?? null)
  //     : null;

  //   console.log('lastYearStart:', lastYearStart);
  //   console.log('lastYearEnd:', lastYearEnd);
  //   console.log('isSingleMonth:', isSingleMonth);
  //   console.log('fixedMonthKey:', fixedMonthKey);

  //   // ── Tracking for debug ──────────────────────────────────────────────────
  //   const skipped:  { reason: string; amt: number; record: any }[] = [];
  //   const placed:   { mk: string; amt: number; dateUsed: string; field: string }[] = [];

  //   // ── Helper: get first valid date with field name ────────────────────────
  //   const getDateAndField = (r: any): { dateStr: string; field: string } | null => {
  //     // ✅ EXACT same priority as buildMonthWiseData()
  //     const candidates: { field: string; value: any }[] = [
  //       { field: 'rcpt_date',         value: r.rcpt_date },
  //       { field: 'crdt_voucher_date', value: r.crdt_voucher_date },
  //       { field: 'rcpt_entry_date',   value: r.rcpt_entry_date },
  //       { field: 'entry_date',        value: r.entry_date },
  //       { field: 'created_at',        value: r.created_at },
  //     ];
  //     for (const c of candidates) {
  //       const v = (c.value || '').toString().trim();
  //       if (v && !v.startsWith('0000') && v !== 'null' && v !== 'undefined') {
  //         return { dateStr: v, field: c.field };
  //       }
  //     }
  //     return null;
  //   };

  //   lastYearData.forEach((record: any, idx: number) => {
  //     const amt = Number(record.total_amt) || 0;

  //     if (!amt) {
  //       skipped.push({ reason: 'zero_amt', amt, record });
  //       return;
  //     }

  //     let mk: string | null = null;
  //     let usedField = '';

  //     if (fixedMonthKey) {
  //       mk = fixedMonthKey;
  //       usedField = 'fixedMonthKey';
  //     } else {
  //       const result = getDateAndField(record);
  //       if (!result) {
  //         skipped.push({ reason: 'no_valid_date', amt, record });
  //         // ⚠️ Still add to total so it doesn't disappear
  //         this.lastYearTotalAmount += amt;
  //         return;
  //       }
  //       mk = this.monthKeyOf(result.dateStr);
  //       usedField = result.field;

  //       if (!mk) {
  //         skipped.push({ reason: 'monthKey_null_from_' + result.field, amt, record });
  //         this.lastYearTotalAmount += amt;
  //         return;
  //       }
  //     }

  //     this.lastYearMonthData[mk] = (this.lastYearMonthData[mk] || 0) + amt;
  //     this.lastYearTotalAmount   += amt;
  //     placed.push({ mk, amt, dateUsed: usedField, field: usedField });
  //   });

  //   // ── Summary log ─────────────────────────────────────────────────────────
  //   console.log('\n✅ PLACED records:', placed.length);
  //   console.log('❌ SKIPPED records:', skipped.length);

  //   // Month breakdown
  //   console.log('\n📅 Month breakdown:');
  //   this.monthKeys.forEach(k => {
  //     if (this.lastYearMonthData[k]) {
  //       console.log(`  ${k}: ₹${this.lastYearMonthData[k].toLocaleString('en-IN')}`);
  //     }
  //   });
  //   console.log('📊 TOTAL:', this.lastYearTotalAmount);

  //   // Expected values from Image 1:
  //   console.log('\n🔍 Expected (from Image 1):');
  //   console.log('  april:     ₹4,32,500');
  //   console.log('  may:       ₹5,66,000');
  //   console.log('  Total:     ₹82,70,700');
  //   console.log('  april diff:', (this.lastYearMonthData['april'] || 0) - 432500);
  //   console.log('  may   diff:', (this.lastYearMonthData['may']   || 0) - 566000);

  //   // Skipped detail
  //   if (skipped.length > 0) {
  //     console.warn('\n⚠️ SKIPPED RECORDS DETAIL:');
  //     const byReason: any = {};
  //     skipped.forEach(s => {
  //       byReason[s.reason] = (byReason[s.reason] || 0) + s.amt;
  //     });
  //     console.table(byReason);
  //     console.log('First 5 skipped:', skipped.slice(0, 5).map(s => ({
  //       reason: s.reason,
  //       amt: s.amt,
  //       rcpt_date: s.record.rcpt_date,
  //       crdt_voucher_date: s.record.crdt_voucher_date,
  //       entry_date: s.record.entry_date,
  //       office_rep: s.record.office_rep_name
  //     })));
  //   }

  //   // April deep-dive
  //   const aprilPlaced = placed.filter(p => p.mk === 'april');
  //   console.log('\n🔎 APRIL placed count:', aprilPlaced.length,
  //               '| total:', aprilPlaced.reduce((s, r) => s + r.amt, 0));
  //   console.log('  field used breakdown:',
  //     aprilPlaced.reduce((acc: any, p) => {
  //       acc[p.field] = (acc[p.field] || 0) + p.amt; return acc;
  //     }, {})
  //   );

  //   console.groupEnd();
  // }

  // buildLastYearMonthData(lastYearData: any[]): void {
  //   this.lastYearMonthData = {};
  //   this.monthKeys.forEach(k => this.lastYearMonthData[k] = 0);
  //   this.lastYearTotalAmount = 0;

  //   if (!lastYearData?.length) return;

  //   const lastYearStart = this.getLastYearStartDate();
  //   const lastYearEnd   = this.getLastYearEndDate();

  //   const isSingleMonth =
  //     lastYearStart.getFullYear() === lastYearEnd.getFullYear() &&
  //     lastYearStart.getMonth()    === lastYearEnd.getMonth();

  //   const fixedMonthKey = isSingleMonth
  //     ? (this.financialMonthMap[lastYearStart.getMonth()] ?? null)
  //     : null;

  //   lastYearData.forEach((record: any) => {
  //     const amt = Number(record.total_amt) || 0;
  //     if (!amt) return;

  //     let mk: string | null = null;

  //     if (fixedMonthKey) {
  //       mk = fixedMonthKey;
  //     } else {
  //       // ✅ EXACT same priority as buildMonthWiseData()
  //       const dateStr =
  //         record.rcpt_date          ||   // PRIMARY — same as buildMonthWiseData
  //         record.crdt_voucher_date  ||
  //         record.rcpt_entry_date    ||
  //         record.entry_date         ||
  //         record.created_at;

  //       if (!dateStr || dateStr.toString().startsWith('0000')) return;
  //       mk = this.monthKeyOf(dateStr);
  //     }

  //     if (mk) {
  //       this.lastYearMonthData[mk] = (this.lastYearMonthData[mk] || 0) + amt;
  //     }
  //     // Always add to total regardless of month resolution
  //     this.lastYearTotalAmount += amt;
  //   });

  //   console.log('✅ Last Year Month Data:', { ...this.lastYearMonthData });
  //   console.log('✅ Last Year Total:', this.lastYearTotalAmount);
  // }


  buildLastYearMonthData(lastYearData: any[]): void {
    this.lastYearMonthData = {};
    this.monthKeys.forEach(k => this.lastYearMonthData[k] = 0);
    this.lastYearTotalAmount = 0;
    this.lastYearNavin = 0;
    this.lastYearNutnikaran = 0;
    this.lastYearNutnikaranBaki = 0;
    this.lastYearMonthSubCount = {};
    this.monthKeys.forEach(k => this.lastYearMonthSubCount[k] = 0);

    if (!lastYearData?.length) return;

    const futureCutoff = new Date();
    futureCutoff.setMonth(futureCutoff.getMonth() + 1);

    const normalize = (val: any): string =>
      (val || '').toString().trim()
        .replace(/\s+/g, ' ')
        .replace(/[^\w\u0900-\u097F ]/g, '')
        .toLowerCase();

    const lastYearStart = this.getLastYearStartDate();
    const lastYearEnd = this.getLastYearEndDate();

    const isSingleMonth =
      lastYearStart.getFullYear() === lastYearEnd.getFullYear() &&
      lastYearStart.getMonth() === lastYearEnd.getMonth();

    const fixedMonthKey = isSingleMonth
      ? (this.financialMonthMap[lastYearStart.getMonth()] ?? null)
      : null;

    // ── STEP 1: Subscriptions + Deposits ──────────────────────────────────
    lastYearData.forEach((record: any) => {
      const amt = Number(record.total_amt) || 0;
      if (!amt) return;

      let mk: string | null = null;

      if (fixedMonthKey) {
        mk = fixedMonthKey;
      } else {
        // ✅ EXACT same priority as buildMonthWiseData()
        const dateStr =
          record.rcpt_date ||
          record.crdt_voucher_date ||
          record.rcpt_entry_date ||
          record.entry_date ||
          record.created_at;

        const cleaned = (dateStr || '').toString().trim();
        if (!cleaned || cleaned.startsWith('0000') || cleaned === 'null') return;
        mk = this.monthKeyOf(cleaned);
      }

      if (mk) {
        this.lastYearMonthData[mk] = (this.lastYearMonthData[mk] || 0) + amt;
      }
      this.lastYearTotalAmount += amt;

      // ✅ नवीन / नूतनीकरण / नूतनीकरणबाकी (excludes deposit, mirrors current year logic)
      if (record.subscription_type !== this.DEPOSIT_TYPE) {
        if (mk) {
          this.lastYearMonthSubCount[mk] = (this.lastYearMonthSubCount[mk] || 0) + 1;
        }

        const subPeriodTo = record.sub_perid_to_date ? new Date(record.sub_perid_to_date) : null;
        const isFuture = !!subPeriodTo && !isNaN(subPeriodTo.getTime()) && subPeriodTo > futureCutoff;

        if (isFuture) {
          if (record.rcpt_type === 'New') {
            this.lastYearNavin++;
          } else {
            this.lastYearNutnikaran++;
          }
        } else {
          this.lastYearNutnikaranBaki++;
        }
      }
    });

    // ── STEP 2: Donations from lastYearExpenseLedgerData ──────────────────

    // ── STEP 2: Donations from lastYearExpenseLedgerData ──────────────────
    const lastYearDonationVouchers: any[] = (this.lastYearExpenseLedgerData || [])
      .reduce((acc: any[], exp: any) => {
        const isDonation =
          normalize(exp.exp_name).includes('देणगी') ||
          normalize(exp.sub_exp_name).includes('वर्गणी विभाग  देणगी') ||
          normalize(exp.sub_exp_name).includes('वर्गणी विभाग - देणगी');
        if (isDonation && Array.isArray(exp.vouchers)) acc.push(...exp.vouchers);
        return acc;
      }, []);

    console.log('🎁 Last Year Donation Vouchers count:', lastYearDonationVouchers.length);

    lastYearDonationVouchers.forEach((v: any) => {
      const donAmt = Number(v.exp_amt) || 0;
      if (!donAmt) return;

      const vDate = this.parseDate(v.voucher_date);
      if (!vDate || isNaN(vDate.getTime())) return;
      if (vDate < lastYearStart || vDate > lastYearEnd) return;

      const mk = fixedMonthKey ?? (this.financialMonthMap[vDate.getMonth()] ?? null);
      if (mk) {
        this.lastYearMonthData[mk] = (this.lastYearMonthData[mk] || 0) + donAmt;
      }
      this.lastYearTotalAmount += donAmt;
    });

    // ── STEP 3: Pending from lastYearVouchersData ──────────────────────────
    const pendingFallbackMk = this.monthKeyOf(this.lastYearStartStr);

    console.log('⏳ Last Year Vouchers count:', (this.lastYearVouchersData || []).length);

    (this.lastYearVouchersData || []).forEach((v: any) => {
      const amt = parseFloat(v.remaining_amt) || parseFloat(v.pending_amount) || 0;
      if (!amt) return;

      const voucherDateStr =
        v.rcpt_date ||
        v.voucher_date ||
        v.entry_date ||
        v.created_at;

      const vDate = this.parseDate(voucherDateStr);
      const mk = fixedMonthKey
        ?? (vDate && !isNaN(vDate.getTime())
          ? (this.financialMonthMap[vDate.getMonth()] ?? pendingFallbackMk)
          : pendingFallbackMk);

      if (mk) {
        this.lastYearMonthData[mk] = (this.lastYearMonthData[mk] || 0) + amt;
      }
      this.lastYearTotalAmount += amt;
    });

    // ── Summary ────────────────────────────────────────────────────────────
    console.group('✅ buildLastYearMonthData FINAL');
    this.monthKeys.forEach(k => {
      if (this.lastYearMonthData[k]) {
        console.log(`  ${k}: ₹${this.lastYearMonthData[k].toLocaleString('en-IN')}`);
      }
    });
    console.log('📊 Total:', this.lastYearTotalAmount);
    console.log('📊 Expected: 8,374,700');
    console.log('📊 Difference:', this.lastYearTotalAmount - 8374700);
    console.groupEnd();
  }


  private getLastYearStartDate(): Date {
    const d = this.parseDate(this.startDate)!;
    d.setFullYear(d.getFullYear() - 1);
    return d;
  }

  private getLastYearEndDate(): Date {
    const d = this.parseDate(this.endDate)!;
    d.setFullYear(d.getFullYear() - 1);
    return d;
  }

  getLastYearMonthTotal(): number { return this.lastYearTotalAmount; }

  getDifferenceForMonth(monthKey: string): number {
    return (this.getMonthTotal(monthKey) || 0) - (this.lastYearMonthData[monthKey] || 0);
  }

  getDifferenceTotal(): number {
    return (this.grandTotalRow.totalAmount || 0) - this.getLastYearMonthTotal();
  }

  getPreviousYearLabel(): string {
    if (!this.startDate) return '';
    const d = this.parseDate(this.startDate)!;
    const year = d.getFullYear();
    return `${year - 1}-${String(year).slice(-2)}`;
  }

  loadExpenseData(): void {
    const request = {
      exp_id: 35, sub_exp_id: '312',
      startdate: this.startDate, enddate: this.endDate
    };
    this.service.getExpenseLedgerReportData(request).subscribe({
      next: (res: any) => {
        this.expenseLedgerData = Array.isArray(res) ? res : [];
        this.expenseLoaded = true;
        this.tryBuild();
      },
      error: () => {
        this.expenseLedgerData = [];
        this.expenseLoaded = true;
        this.tryBuild();
      }
    });
  }

  loadVouchersData(): void {
    this.service.getvoucherbySub(this.startDate, this.endDate).subscribe({
      next: (res: any) => {
        this.getallVouchersData = Array.isArray(res) ? res : (res?.data || []);
        this.vouchersLoaded = true;
        this.tryBuild();
      },
      error: () => {
        this.getallVouchersData = [];
        this.vouchersLoaded = true;
        this.tryBuild();
      }
    });
  }

  tryBuild(): void {
    if (this.expenseLoaded && this.vouchersLoaded) this.buildMonthWiseData();
  }

  buildMonthWiseData(): void {
    // if (!this.offrepwiseData?.length) { this.isLoading = false; return; }

    if (!this.offrepwiseData?.length) { this.isLoading = false; return; }

    // Guard: ensure fiscalYear is set
    if (!this.fiscalYear) {
      const sd = this.parseDate(this.startDate);
      if (sd) {
        const y = sd.getMonth() >= 3 ? sd.getFullYear() : sd.getFullYear() - 1;
        this.fiscalYear = `${y}-${String(y + 1).slice(-2)}`;
      }
    }

    if (!Array.isArray(this.expenseLedgerData)) this.expenseLedgerData = [];
    if (!Array.isArray(this.getallVouchersData)) this.getallVouchersData = [];

    const normalize = (val: any): string =>
      (val || '').toString().trim()
        .replace(/\s+/g, ' ')
        .replace(/[^\w\u0900-\u097F ]/g, '')
        .toLowerCase();

    const start = this.parseDate(this.startDate)!;
    const end = this.parseDate(this.endDate)!;
    const isSingleMonth =
      start.getFullYear() === end.getFullYear() &&
      start.getMonth() === end.getMonth();
    const fixedMonthKey = isSingleMonth ? this.monthKeyOf(this.startDate) : null;
    const futureCutoff = new Date();
    futureCutoff.setMonth(futureCutoff.getMonth() + 1);

    const allVouchers: any[] = this.expenseLedgerData.reduce((acc: any[], exp: any) => {
      const isDonation =
        normalize(exp.exp_name).includes('देणगी') ||
        normalize(exp.sub_exp_name).includes('वर्गणी विभाग  देणगी');
      if (isDonation && Array.isArray(exp.vouchers)) acc.push(...exp.vouchers);
      return acc;
    }, []);

    const donationMap: {
      [repKey: string]: { totalCount: number; byMonth: { [mk: string]: number } }
    } = {};

    allVouchers.forEach((v: any) => {
      const rep = normalize(v.rep_name);
      if (!rep) return;
      const vDate = this.parseDate(v.voucher_date);
      if (!vDate || isNaN(vDate.getTime())) return;
      if (vDate < start || vDate > end) return;

      if (!donationMap[rep]) donationMap[rep] = { totalCount: 0, byMonth: {} };
      donationMap[rep].totalCount += 1;

      const mk = fixedMonthKey ?? (this.financialMonthMap[vDate.getMonth()] ?? null);
      if (mk) {
        donationMap[rep].byMonth[mk] =
          (donationMap[rep].byMonth[mk] || 0) + (Number(v.exp_amt) || 0);
      }
    });

    const representativeMasterMap: any = {};
    (this.offrepwiseData || []).forEach((r: any) => {
      const repKey = normalize(r.rep_name);
      if (!repKey) return;
      if (!representativeMasterMap[repKey] && r.office_rep_name) {
        representativeMasterMap[repKey] = { office_rep_name: r.office_rep_name };
      }
    });

    const pendingByOfficeRep: { [officeRep: string]: { [mk: string]: number } } = {};
    let itorPendingAmount = 0;
    const itorPendingByMonth: { [mk: string]: number } = {};
    const pendingFallbackMonthKey = this.monthKeyOf(this.startDate);

    this.getallVouchersData.forEach((v: any) => {
      const amt = parseFloat(v.remaining_amt) || 0;
      if (!amt) return;

      let officeRepRaw = (v.office_rep_name || '').toString().trim();
      if (
        !officeRepRaw ||
        officeRepRaw === '-' ||
        officeRepRaw.toLowerCase() === 'unknown' ||
        officeRepRaw.toLowerCase() === 'null'
      ) {
        const repKey = normalize(v.rep_name || v.representative_name || v.name || '');
        officeRepRaw = representativeMasterMap[repKey]?.office_rep_name || '';
      }

      const officeRepNorm = normalize(officeRepRaw);
      const voucherDateStr = v.rcpt_date || v.voucher_date || v.entry_date || v.created_at;
      const vDate = this.parseDate(voucherDateStr);
      const mk = fixedMonthKey
        ?? (vDate && !isNaN(vDate.getTime())
          ? (this.financialMonthMap[vDate.getMonth()] ?? pendingFallbackMonthKey)
          : pendingFallbackMonthKey);

      if (officeRepNorm) {
        if (!pendingByOfficeRep[officeRepNorm]) pendingByOfficeRep[officeRepNorm] = {};
        pendingByOfficeRep[officeRepNorm][mk!] =
          (pendingByOfficeRep[officeRepNorm][mk!] || 0) + amt;
      } else {
        itorPendingAmount += amt;
        if (mk) itorPendingByMonth[mk] = (itorPendingByMonth[mk] || 0) + amt;
      }
    });

    const uniqueOfficeReps = (this.uniqueData(
      this.offrepwiseData, (a: any) => normalize(a.office_rep_name)
    ) as any[]).sort((a: any, b: any) => {
      const iA = this.OFFICE_REP_ORDER.findIndex(
        o => normalize(o) === normalize(a.office_rep_name || '')
      );
      const iB = this.OFFICE_REP_ORDER.findIndex(
        o => normalize(o) === normalize(b.office_rep_name || '')
      );
      if (iA !== -1 && iB !== -1) return iA - iB;
      if (iA !== -1) return -1;
      if (iB !== -1) return 1;
      return (a.office_rep_name || '').localeCompare(b.office_rep_name || '');
    });

    this.grandTotalRow = this.createEmptyRow('एकूण');
    this.officeRepRows = [];

    uniqueOfficeReps.forEach((repItem: any, index: number) => {
      const officeName = repItem.office_rep_name;
      const normalizedOfficeName = normalize(officeName);

      const officeRecords = this.offrepwiseData.filter(
        (r: any) => normalize(r.office_rep_name) === normalizedOfficeName
      );

      const row = this.createEmptyRow(officeName);
      row.srNo = index + 1;
      row.target_sub = 0;
      row.target_amount = 0;

      const processedRepForDonation = new Set<string>();

      officeRecords.forEach((record: any) => {
        const subType = record.subscription_type || '';
        const amt = Number(record.total_amt) || 0;

        let mk: string | null;
        if (fixedMonthKey) {
          mk = fixedMonthKey;
        } else {
          const dateStr = record.rcpt_date
            || record.crdt_voucher_date
            || record.rcpt_entry_date
            || record.entry_date
            || record.created_at;
          mk = this.monthKeyOf(dateStr);
        }

        if (subType !== this.DEPOSIT_TYPE) {
          row.totalSub++;
          row.totalSubscriptionAmount += amt;
          if (mk) row[mk] = (row[mk] || 0) + amt;
          if (mk) row[mk + '_cnt'] = (row[mk + '_cnt'] || 0) + 1;

          // ✅ नवीन / नूतनीकरण / नूतनीकरणबाकी classification

          // ✅ नवीन / नूतनीकरण / नूतनीकरणबाकी (same logic as AllBusinessReportSubscriptionComponent)
          const subPeriodTo = record.sub_perid_to_date ? new Date(record.sub_perid_to_date) : null;
          const isFuture = !!subPeriodTo && !isNaN(subPeriodTo.getTime()) && subPeriodTo > futureCutoff;

          if (isFuture) {
            if (record.rcpt_type === 'New') {
              row.navin++;
            } else {
              row.nutnikaran++;
            }
          } else {
            row.nutnikaranBaki++;
          }
        } else {
          row.totalDepositAmount += amt;
          if (mk) row[mk] = (row[mk] || 0) + amt;
        }

        const repKey = normalize(record.rep_name);
        if (repKey && !processedRepForDonation.has(repKey)) {
          const donInfo = donationMap[repKey];
          if (donInfo) {
            row.totalDonationCount += donInfo.totalCount;
            Object.entries(donInfo.byMonth).forEach(([donMk, donAmt]) => {
              row.totalDonationAmount += donAmt as number;
              row[donMk] = (row[donMk] || 0) + (donAmt as number);
            });
          }
          processedRepForDonation.add(repKey);
        }
      });

      const pendingMonths = pendingByOfficeRep[normalizedOfficeName] || {};
      let totalPending = 0;
      Object.entries(pendingMonths).forEach(([mk, pendAmt]) => {
        totalPending += pendAmt as number;
        row[mk] = (row[mk] || 0) + (pendAmt as number);
      });
      row.totalPendingAmount = totalPending;

      row.totalAmount =
        row.totalSubscriptionAmount +
        row.totalDepositAmount +
        row.totalDonationAmount +
        row.totalPendingAmount;

      this.officeRepRows.push(row);
      this.addToGrandTotal(row);
    });

    if (itorPendingAmount > 0) {
      const itorRow = this.createEmptyRow('इतर');
      itorRow.srNo = this.officeRepRows.length + 1;
      itorRow.target_sub = 0;
      itorRow.target_amount = 0;
      itorRow.totalPendingAmount = itorPendingAmount;

      Object.entries(itorPendingByMonth).forEach(([mk, amt]) => {
        itorRow[mk] = (itorRow[mk] || 0) + (amt as number);
      });

      itorRow.totalAmount = itorPendingAmount;
      this.officeRepRows.push(itorRow);
      this.addToGrandTotal(itorRow);
    }

    this.loadUdhistha();
    console.log('=== GRAND TOTAL ===', this.grandTotalRow.totalAmount);
    this.isLoading = false;
  }

  // addToGrandTotal(row: any): void {
  //   this.grandTotalRow.totalSub += row.totalSub || 0;
  //   this.grandTotalRow.totalSubscriptionAmount += row.totalSubscriptionAmount || 0;
  //   this.grandTotalRow.totalDepositAmount += row.totalDepositAmount || 0;
  //   this.grandTotalRow.totalDonationAmount += row.totalDonationAmount || 0;
  //   this.grandTotalRow.totalDonationCount += row.totalDonationCount || 0;
  //   this.grandTotalRow.totalPendingAmount += row.totalPendingAmount || 0;
  //   this.grandTotalRow.totalAmount =
  //     this.grandTotalRow.totalSubscriptionAmount +
  //     this.grandTotalRow.totalDepositAmount +
  //     this.grandTotalRow.totalDonationAmount +
  //     this.grandTotalRow.totalPendingAmount;
  //   this.monthKeys.forEach(k => {
  //     this.grandTotalRow[k] = (this.grandTotalRow[k] || 0) + (row[k] || 0);
  //   });
  // }

  getMonthTotal(monthKey: string): number {
    return this.officeRepRows.reduce((s, r) => s + (r[monthKey] || 0), 0);
  }

  // createEmptyRow(name: string): any {
  //   const row: any = {
  //     name, srNo: 0, office_rep_name: name,
  //     totalSub: 0, totalSubscriptionAmount: 0,
  //     totalDepositAmount: 0, totalDonationAmount: 0,
  //     totalDonationCount: 0, totalPendingAmount: 0,
  //     totalAmount: 0, target_sub: 0, target_amount: 0
  //   };
  //   this.monthKeys.forEach(k => row[k] = 0);
  //   return row;
  // }

  getPercentage(actual: number, target: number): string {
    if (!target || target === 0) return '0.00';
    return ((actual / target) * 100).toFixed(2);
  }

  get grandTargetSub(): number {
    return this.officeRepRows.reduce((s, r) => s + (Number(r.target_sub) || 0), 0);
  }

  get grandTargetAmount(): number {
    return this.officeRepRows.reduce((s, r) => s + (Number(r.target_amount) || 0), 0);
  }

  onTargetChange(): void { }

  getKey(name: string): string { return name.split(' ').join('_'); }

  uniqueData(data: any[], key: (a: any) => any): any[] {
    return [...new Map(data.map(a => [key(a), a])).values()];
  }

  getMarathiDate(dateStr: string): string {
    if (!dateStr) return '';
    const d = this.parseDate(dateStr);
    if (!d) return '';
    return `${this.marathiMonths[d.toLocaleString('en-US', { month: 'long' })] || ''} ${d.getFullYear()}`;
  }

  exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, fileName + '.xlsx');
  }

  show = false;

  printPage(): void {
    this.show = true;
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) return;
    const pw = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');
    if (pw) {
      pw.document.open();
      pw.document.write(`<html><head><title>Month Wise Business Report</title>
        <style>
          @media print {
            @page { size: A3 landscape; margin: 5mm; }
            body { font-family: Arial, sans-serif; font-size: 12px; margin: 0; padding: 5mm; }
            table { width: 100%; border-collapse: collapse; table-layout: auto; }
            th, td { padding: 2px; border: 1px solid black; text-align: center; font-size: 11px; white-space: nowrap; }
            th { font-weight: bold; white-space: normal; word-break: break-word; }
            tr { page-break-inside: avoid; }
            thead { display: table-header-group; }
            .noPrint { display: none !important; }
            .printOnly { display: inline !important; }
            input { display: none !important; }
          }
          .printOnly { display: none; }
        </style></head><body>
        <div id="print-section">${printContent}</div>
        <script>window.onload=function(){window.print();setTimeout(()=>{window.close();},500);};<\/script>
      </body></html>`);
      pw.document.close();
    }
  }


  private getLastYearDateStr(dateStr: string): string {
    const d = this.parseDate(dateStr);
    if (!d) return '';
    d.setFullYear(d.getFullYear() - 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  get lastYearStartStr(): string { return this.getLastYearDateStr(this.startDate); }
  get lastYearEndStr(): string { return this.getLastYearDateStr(this.endDate); }

  loadLastYearExpenseData(): void {
    const request = {
      exp_id: 35, sub_exp_id: '312',
      startdate: this.lastYearStartStr,
      enddate: this.lastYearEndStr
    };
    this.service.getExpenseLedgerReportData(request).subscribe({
      next: (res: any) => {
        this.lastYearExpenseLedgerData = Array.isArray(res) ? res : [];
        this.lastYearExpenseLoaded = true;
        this.tryBuildLastYear();
      },
      error: () => {
        this.lastYearExpenseLedgerData = [];
        this.lastYearExpenseLoaded = true;
        this.tryBuildLastYear();
      }
    });
  }

  loadLastYearVouchersData(): void {
    this.service.getvoucherbySub(this.lastYearStartStr, this.lastYearEndStr).subscribe({
      next: (res: any) => {
        this.lastYearVouchersData = Array.isArray(res) ? res : (res?.data || []);
        this.lastYearVouchersLoaded = true;
        this.tryBuildLastYear();
      },
      error: () => {
        this.lastYearVouchersData = [];
        this.lastYearVouchersLoaded = true;
        this.tryBuildLastYear();
      }
    });
  }

  tryBuildLastYear(): void {
    if (this.lastYearExpenseLoaded && this.lastYearVouchersLoaded) {
      const lastYearRaw = this.data?.lastYearOffrepwisedata || [];
      this.buildLastYearMonthData(lastYearRaw);
    }
  }

  createEmptyRow(name: string): any {
    const row: any = {
      name, srNo: 0, office_rep_name: name,
      totalSub: 0, totalSubscriptionAmount: 0,
      totalDepositAmount: 0, totalDonationAmount: 0,
      totalDonationCount: 0, totalPendingAmount: 0,
      totalAmount: 0, target_sub: 0, target_amount: 0,
      navin: 0, nutnikaran: 0, nutnikaranBaki: 0
    };
    this.monthKeys.forEach(k => row[k] = 0);
    return row;
  }


  addToGrandTotal(row: any): void {
    this.grandTotalRow.totalSub += row.totalSub || 0;
    this.grandTotalRow.totalSubscriptionAmount += row.totalSubscriptionAmount || 0;
    this.grandTotalRow.totalDepositAmount += row.totalDepositAmount || 0;
    this.grandTotalRow.totalDonationAmount += row.totalDonationAmount || 0;
    this.grandTotalRow.totalDonationCount += row.totalDonationCount || 0;
    this.grandTotalRow.totalPendingAmount += row.totalPendingAmount || 0;
    this.grandTotalRow.navin += row.navin || 0;
    this.grandTotalRow.nutnikaran += row.nutnikaran || 0;
    this.grandTotalRow.nutnikaranBaki += row.nutnikaranBaki || 0;
    this.grandTotalRow.totalAmount =
      this.grandTotalRow.totalSubscriptionAmount +
      this.grandTotalRow.totalDepositAmount +
      this.grandTotalRow.totalDonationAmount +
      this.grandTotalRow.totalPendingAmount;
    this.monthKeys.forEach(k => {
      this.grandTotalRow[k] = (this.grandTotalRow[k] || 0) + (row[k] || 0);
      this.grandTotalRow[k + '_cnt'] = (this.grandTotalRow[k + '_cnt'] || 0) + (row[k + '_cnt'] || 0);
    });
  }


  getDifferenceNavin(): number {
    return (this.grandTotalRow.navin || 0) - (this.lastYearNavin || 0);
  }
  getDifferenceNutnikaran(): number {
    return (this.grandTotalRow.nutnikaran || 0) - (this.lastYearNutnikaran || 0);
  }
  getDifferenceNutnikaranBaki(): number {
    return (this.grandTotalRow.nutnikaranBaki || 0) - (this.lastYearNutnikaranBaki || 0);
  }


  getCurrentYearFullLabel(): string {
    if (!this.startDate) return '';
    const d = this.parseDate(this.startDate)!;
    const year = d.getFullYear();
    return `${year}-${year + 1}`;
  }

  getPreviousYearFullLabel(): string {
    if (!this.startDate) return '';
    const d = this.parseDate(this.startDate)!;
    const year = d.getFullYear();
    return `${year - 1}-${year}`;
  }

  getDifferenceSubCountForMonth(monthKey: string): number {
    return (this.grandTotalRow[monthKey + '_cnt'] || 0) - (this.lastYearMonthSubCount[monthKey] || 0);
  }

  getLastYearTotalSubCount(): number {
    return this.lastYearNavin + this.lastYearNutnikaran + this.lastYearNutnikaranBaki;
  }

  // loadUdhistha(): void {
  //   fetch(`${this.UDHISTHA_API}?financial_year=${encodeURIComponent(this.fiscalYear)}`)
  //     .then(r => r.json())
  //     .then((res: any) => {
  //       if (res.status === 'success' && Array.isArray(res.data)) {
  //         res.data.forEach((saved: any) => {
  //           const row = this.officeRepRows.find(r =>
  //             (r.office_rep_name || '').trim() === saved.office_rep_name.trim()
  //           );
  //           if (row) {
  //             row.target_sub = saved.target_sub;
  //             row.target_amount = saved.target_amount;
  //           }
  //         });
  //       }
  //     })
  //     .catch(err => console.error('Udhistha load error:', err));
  // }

  loadUdhistha(): void {
  console.log('Loading udhistha for fiscalYear:', this.fiscalYear); // add this
  console.log('officeRepRows names:', this.officeRepRows.map(r => r.office_rep_name)); // add this
  fetch(`${this.UDHISTHA_API}?financial_year=${encodeURIComponent(this.fiscalYear)}`)
    .then(r => r.json())
    .then((res: any) => {
      console.log('Udhistha API response:', res); // add this
      if (res.status === 'success' && Array.isArray(res.data)) {
        res.data.forEach((saved: any) => {
          const row = this.officeRepRows.find(r =>
            (r.office_rep_name || '').trim() === saved.office_rep_name.trim()
          );
          if (row) {
            row.target_sub    = saved.target_sub;
            row.target_amount = saved.target_amount;
          }
        });
      }
    })
    .catch(err => console.error('Udhistha load error:', err));
}

  saveUdhistha(row: any): void {
    fetch(this.UDHISTHA_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        office_rep_name: row.office_rep_name,
        financial_year: this.fiscalYear,
        target_sub: row.target_sub || 0,
        target_amount: row.target_amount || 0
      })
    })
      .then(r => r.json())
      .then(res => console.log('Saved:', res))
      .catch(err => console.error('Save error:', err));
  }
}